







import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";


@Component
export default class Button extends Vue {
  @Prop()
  onClick: (e: Event) => void;

  @Prop()
  classes: string;

  @Prop()
  disabled: boolean;

  @Prop()
  type: string;

  @Prop()
  shouldPreventDefault: boolean;

  @Prop()
  shouldStopPropagation: boolean;

  @Prop()
  event: string;

  @Prop()
  eventCategory: string;

  @Prop()
  eventLabel: string;

  @Prop()
  eventValue: string;

  @Prop()
  eventAction: string;

  handleClick (e: Event) {
    if (this.shouldPreventDefault) {
      e.preventDefault();
    }

    if (this.shouldStopPropagation) {
      e.stopPropagation();
    }

    try {
      Vue.prototype.$gtm.trackEvent({
        event: this.event ? this.event : null,
        category: this.eventCategory ? this.eventCategory : "Portal Button",
        action: this.eventAction ? this.eventAction : "click",
        label: this.eventLabel ? this.eventLabel : this.defaultLabel(),
        value: this.eventValue ? this.eventValue : null
      });
    } catch (ex) {
      window.console.error("Failed to track event. " + ex);
    }

    if (this.onClick) {
      this.onClick(e);
    }
    this.$emit("click");
  }

  defaultLabel () {
    if (this.$slots.default[0].elm.parentElement.title) {
      return this.$slots.default[0].elm.parentElement.title;
    } else if (this.$slots.default[0].children) {
      return this.$slots.default[0].children[0].text;
    } else {
      return this.$slots.default[0].text;
    }
  }
}

